export default __webpack_public_path__ + "static/media/B150.7b942006.jpg";